export default __webpack_public_path__ + "images/13f29d10d10aa57ccac28a2d3b2e4ed4-blues.webp";